import React, { useRef, useEffect } from 'react';
import { latLngBounds, LatLngExpression } from 'leaflet';
import { useMap } from 'react-leaflet';


export interface MapFitBoundsHandlerProps {
    readonly positions?: readonly LatLngExpression[] | undefined;

    // Whether or not to center the map only once. Most of the time we want to do it once because keep automatically centering the
    // map whenever something changed is not very use friendly. However, we will allow to set this to false for some cases.
    readonly updateBoundOnce: boolean;
}



/**
 * This is a dummy component used for setting the map's bounds to fit the markers
 */
export const MapFitBoundsHandler: React.FC<MapFitBoundsHandlerProps> = (props: MapFitBoundsHandlerProps) => {
    const map = useMap();
    const done = useRef<boolean>(false);
    useEffect(() => {
        if (props.positions && props.positions.length > 0 && (!props.updateBoundOnce || !done.current)) {
            map.fitBounds(latLngBounds([...props.positions]));
            done.current = true;
        }
    }, [map, props.positions, props.updateBoundOnce]);

    return (<></>);
};
